module.exports = __webpack_public_path__ + "static/stardust-image-circular-a7e681d0bf011a43126e1b16b3f26662.png";